<template>
  <RegistrationLayout>
    <template v-slot:header>
      <HMButton
        color="white"
        rounded="full"
        size="x-small"
        fontWeight="semibold"
        textSize="small"
        padding="tight"
        @click="back"
      >
        <span>
          <Icon
            :iconClass="`fas ${isLastStep ? 'fa-times' : 'fa-chevron-left'}`"
          />
          {{ isLastStep ? $t('common.cancel_btn') : $t('common.back_btn') }}
        </span>
      </HMButton>
      <p v-if="step === '1.a'" class="flex ml-auto text-black">
        {{ $t('registration.member_info.already_registered') }}
        <router-link
          class="ml-4 font-semibold"
          :to="{ name: 'login' }"
          v-text="$t('registration.member_info.sign_in')"
        />
      </p>
    </template>
    <template v-slot:default>
      <MemberInfo v-if="step === '1.a'" @member-found="handleMember" @duplicate-found="handleDuplicateMembers" />
      <MemberNumber v-if="step === '1.b'" :initial-eligibility-data="eligibilityData" @member-found="handleMember" />
      <SelecRegistrationModality v-if="step === '2'" @next="goToStep('3')" />
      <VerifyIdentityRegistration v-if="step === '3'" @next="goToStep('4')" />
      <CommunicationPreferences v-if="step === '4'" @next="goToStep('5')" />
      <PasswordInfo v-if="step === '5'" />
    </template>
  </RegistrationLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MemberInfo from './MemberInfo'
import MemberNumber from './MemberNumber'
import CommunicationPreferences from './CommunicationPreferences'
import PasswordInfo from './PasswordInfo'
import RegistrationLayout from '@components/layouts/RegistrationLayout'
import SelecRegistrationModality from './verify-identity/SelecRegistrationModality.vue'
import VerifyIdentityRegistration from './verify-identity/VerifyIdentityRegistration.vue'

export default {
  components: {
    MemberInfo,
    MemberNumber,
    SelecRegistrationModality,
    VerifyIdentityRegistration,
    CommunicationPreferences,
    PasswordInfo,
    RegistrationLayout,
  },
  data() {
    return {
      step: '1.a',
      historyStack: [],
      eligibilityData: null,
    }
  },

  computed: {
    ...mapGetters('member', ['isAuthenticated']),
    isLastStep() {
      return this.step === '5'
    },
  },

  methods: {
    ...mapActions(['logout']),
    handleMember(eligibilityData) {
      this.eligibilityData = eligibilityData
      this.goToStep('2')
    },
    handleDuplicateMembers(eligibilityData) {
      this.eligibilityData = eligibilityData
      this.goToStep('1.b')
    },
    goToStep(nextStep) {
      this.historyStack.push(this.step)
      this.step = nextStep
    },
    back() {
      const previousStep = this.historyStack.pop()
      if (!previousStep || this.isLastStep) {
        this.historyStack = []

        if (this.isAuthenticated) {
          this.logout()
        }

        this.$router.replace('/login')
      } else {
        this.step = previousStep
      }
    },
  },

  watch: {
    historyStack: {
      deep: true,
      handler: () => {
        /* NO-OP: needed to avoid NPE */
      },
    },
  },
}
</script>
